import { ReactElement, useEffect } from 'react';
import { VStack, Text, Button } from '@chakra-ui/react';
import { PageContext } from 'components/common/PageContext';
import { useNavigate } from 'react-router-dom';
import { PublicRoutes } from 'types/Routes';
import { CheckIconLarge } from 'assets/common/CheckIconLarge';
import { RegisterStepProps } from 'pages/auth/Registration';
import { InAppLayoutVariant } from 'types/Layout';

export const RegisterStep3 = ({ values }: RegisterStepProps): ReactElement => {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate(PublicRoutes.LOGIN);
    }, 15000);
  });

  return (
    <PageContext
      title="Registrierung"
      customOnBackClick={() => null}
      variant={InAppLayoutVariant.TERTIARY}
    >
      <VStack gap="xl" pt="12">
        <CheckIconLarge w="149px" h="96px" mb="10" />
        <Text textStyle="h1.medium" textAlign="center" color="text.primary">
          Du hast Post von uns!
        </Text>
        <Text textAlign="center" textStyle="h4.regular" color="text.quaternary">
          Du wirst automatisch zum Login geleitet. Dort kannst du dich direkt anmelden und mit
          Novaheal lernen.
        </Text>
        <Text
          textAlign="center"
          textStyle="h3.medium"
          color="text.accent"
          pb="10"
          maxWidth="100vw"
          px="l"
        >
          {values.email}
        </Text>
        <Button variant="primary" w="full" onClick={() => navigate(PublicRoutes.LOGIN)}>
          Zum Login
        </Button>
      </VStack>
    </PageContext>
  );
};
